import React from "react";
import "./colorBar.css";

const ColorBarPanel = ({ children }) => (
  <div className="colorbar-panel">{children}</div>
);

export default ColorBarPanel;
